import Vue from 'vue'
import store from '@/store/index'

/**
 * @Description: 权限API接口
 * @author Lu Jie
 * @date 2020/7/10
 */
var permission = {
    /**
     * 判断是否具备页面操作权限
     * @param path 网页地址
     * @param name 操作名称
     * @returns {boolean} 是否具备操作权限
     * @constructor
     */
    HasOperationPermission: function(path, name) {
        let permissions = store.getters.menus;
        if (permissions == undefined || permissions == null || permissions.length == 0) {
            return false;
        }
        let pers = [];
        LYCom.Find(permissions, "Children", item => {
            return item.url == path;
        }, pers);

        if (pers.length == 0) {
            return false;
        }
        let operationStr = pers[0].permission;
        if (!LYCom.StringIsEmpty(operationStr)) {
            if (operationStr && operationStr != null && operationStr.indexOf(name) != -1) {
                return true;
            }
        }
        return false;
    },

    /**
     * 判断是否具备菜单权限
     * @param path 地址
     * @returns {boolean} 是否具备
     * @constructor
     */
    HasMenuPermission: function(path) {
        return true;
    },

    /**
     * 获取左边菜单
     * @constructor
     */
    GetLeftMenus: function() {
        let menus = JSON.parse(JSON.stringify(store.getters.menus));
        if (menus == undefined || menus == null || menus.length == 0) {
            return null;
        }
        //删除非顶部菜单
        for (let i = menus.length - 1; i >= 0; i--) {
            if (menus[i].visible == 0) {
                delete menus[i];
            } else {
                this.deleteLeftChildren(menus[i].Children);
            }
        }
        //去掉数组为空的部分
        menus = this.filterChildren(menus);

        return menus;
    },
    /**
     * 删除非顶部子菜单
     * @param children
     */
    deleteLeftChildren(children) {
        if (children) {
            for (let i = children.length - 1; i >= 0; i--) {
                if (children[i].visible == 0) {
                    delete children[i];
                } else {
                    this.deleteLeftChildren(children[i].Children);
                }
            }
        }
    },
    /**
     * 获取顶层菜单
     * @returns {*}
     * @constructor
     */
    GetTopMenus: function() {
        let menus = JSON.parse(JSON.stringify(store.getters.menus));
        if (menus == undefined || menus == null || menus.length == 0) {
            return null;
        }
        //删除非顶部菜单
        for (let i = menus.length - 1; i >= 0; i--) {
            if (menus[i].visible == 0 || menus[i].necessary == 0) {
                delete menus[i];
            } else {
                this.deleteChildren(menus[i].Children);
            }
        }
        //去掉数组为空的部分
        menus = this.filterChildren(menus);

        return menus;
    },
    /**
     * 删除非顶部子菜单
     * @param children
     */
    deleteChildren(children) {
        if (children) {
            for (let i = children.length - 1; i >= 0; i--) {
                if (children[i].visible == 0 || children[i].necessary == 0) {
                    delete children[i];
                } else {
                    this.deleteChildren(children[i].Children);
                }
            }
        }
    },
    /**
     * 去掉子菜单中数组为空的部分
     * @param children
     * @returns {*}
     */
    filterChildren(children) {
        if (children) {
            let result = children.filter(function(val) {
                return val;
            });
            for (let i = 0; i < result.length; i++) {
                if (result[i].Children) {
                    result[i].Children = this.filterChildren(result[i].Children);
                }
            }
            return result;
        }
        return null;
    },
    /**
     * 根据地址获取菜单
     * @param url
     * @constructor
     */
    GetMenuByUrl(url) {
        let menus = JSON.parse(JSON.stringify(store.getters.menus));
        let result = [];
        LYCom.Find(menus, "Children", item => {
            return item.url == url;
        }, result);
        return result;
    },
    /**
     * 根据名称获取菜单列表
     * @param name 菜单名称
     * @returns {any} 菜单列表
     * @constructor
     */
    GetMenuByName(name) {
        let menus = JSON.parse(JSON.stringify(store.getters.menus));
        let result = [];
        LYCom.Find(menus, "Children", item => {
            return item.name == name;
        }, result);
        return result;
    }
}

Vue.prototype.$permission = permission;


// WEBPACK FOOTER //
// ./src/api/permission.js